// Brand colours: the single source for the theme and for code that styles by hand
export const colors = {
    primary    : '#3179FF', // brand blue (logo dot, buttons, links)
    primaryTint: '#EAF2FF', // pale primary for selected / highlighted backgrounds
    titleBlue  : '#324483', // navy headings
    dividerBlue: '#DEEEFF',
    textDark   : '#171725',
    textGrey   : '#585D72',
    subtitleGrey: '#717480',
};

export const fontFamily = 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif';
